import { createEvent, restore, sample } from 'effector'
import { ChangeAmountRequest } from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'
import { WithdrawalEdit } from '../../../edit'
import { RequestError } from '../../../../../../shared/errorResponse'
import { withdrawalMounted } from '../../../edit/model'

export const calculateAmountMounted = createEvent<ChangeAmountRequest>()

export const updateAmountMounted = createEvent<ChangeAmountRequest>()

export const calculateAmount = fx<ChangeAmountRequest, WithdrawalEdit>({
  method: 'PUT',
  url: `/transaction_request/withdrawal_amount/`,
})

export const updateAmount = fx<ChangeAmountRequest, WithdrawalEdit>({
  method: 'PUT',
  url: `/transaction_request/withdrawal_amount/`,
})

export const setChangedAmountData = createEvent<WithdrawalEdit | null>()

export const setUpdateAmountRequestSuccess = createEvent<boolean>()

export const setError = createEvent<RequestError>()

export const $changedAmountData = restore(setChangedAmountData, null)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const $updateAmountRequestSuccess = restore(
  setUpdateAmountRequestSuccess,
  false,
)

sample({
  clock: calculateAmountMounted,
  source: $params,
  fn: (params, item) => {
    let id
    if (params) {
      id = params.withdrawalID
    }

    return {
      body: {
        ...item,
      },
      url: `/transaction_request/withdrawal_amount/${id}`,
    }
  },
  target: calculateAmount,
})

sample({
  clock: updateAmountMounted,
  source: $params,
  fn: (params, item) => {
    let id
    if (params) {
      id = params.withdrawalID
    }

    return {
      body: {
        ...item,
      },
      url: `/transaction_request/withdrawal_amount/${id}`,
    }
  },
  target: updateAmount,
})

sample({
  clock: [calculateAmount.doneData, updateAmount.doneData],
  fn: (doneData) => doneData.body,
  target: [setChangedAmountData, withdrawalMounted],
})

sample({
  clock: [updateAmount.doneData],
  fn: ({}) => true,
  target: setUpdateAmountRequestSuccess,
})

sample({
  clock: [calculateAmount.failData, updateAmount.failData],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})
